export default __webpack_public_path__ + "static/media/ladiko-suites.b7fac765.jpg";